import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';

const Image = (_a) => {
    var { className, asChild = false } = _a, props = __rest(_a, ["className", "asChild"]);
    const Comp = asChild ? Slot : "img";
    return jsx(Comp, Object.assign({ className: className }, props));
};
Image.displayName = "Image";

export { Image };
